import React from 'react';

// Componentes Front-end

import '../style/style.css';
import '../style/diretrizes.css';
import '../style/componentes.css';


//Componentes de roteamento


export default class Instrucao extends React.Component {
    render() {
        return (
            <div className="dialogo col">
                <div className='row center'>
                    <div  className='dialogoTitle bkColor2'>
                        <h2 className='Color3' >{this.props.title} </h2>
                    </div>
                </div>
                <div className='row center'>
                    <div className='dialogoContent opacidade bkColor1 Color4'>
                        
                        <div className="dialogoMain col center fullWidth center">
                            <div className="row center fullWidth">
                            <p className="Color4">{this.props.content}</p>
                            </div>
                            <div className="row center fullWidth">
                            {this.props.contentButton}
                            </div>
                        </div>
                        <div className="dialogoRodape row center fullWidth end">
                            {this.props.button}
                        </div>
                    
                    </div>
                   
                </div>
                <div className='dialogoNav row center'>
                        {this.props.nav1}
                        {this.props.nav2}
                
                    
                </div>
                
            </div>
        );
    }
}